module.exports = "/_next/static/images/151ba2522b2876b2bc9420a741093ee7-nubanker-pm@0.75x.jpg";